/* global FormData */
import React, { useState, useRef, useContext } from 'react'
// import useToastContext from 'hooks/useToastContext'
import { useTranslation } from 'react-i18next'
import OImage from 'components/reusable/OImage'
import { apiPost } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import AuthContext from 'context/AuthContext'

const ReArrangeModal = ({
  setIsShowModal,
  photos,
  propertyId,
  getPropertyById
  ,reArrange
  ,setReArrange
}) => {
  const dragItem = useRef()
  const [list, setList] = useState(photos)
  const { config } = useContext(AuthContext);

  const dragOverItem = useRef()
  const dragStart = (e, position) => {
    dragItem.current = position
    console.log(e.target.innerHTML)

  }
  const dragEnter = (e, position) => {
    dragOverItem.current = position
    console.log(e.target.innerHTML)

  }
  const drop = e => {
    const copyListItems = [...list]
    const dragItemContent = copyListItems[dragItem.current]
    copyListItems.splice(dragItem.current, 1)
    copyListItems.splice(dragOverItem.current, 0, dragItemContent)
    dragItem.current = null
    dragOverItem.current = null
    setList(copyListItems)
  }
  const { t } = useTranslation()
  // const notification = useToastContext()
  const UploadPhotos = async () => {

    const { data: response } = await apiPost(apiPath.rearrangePhotos, {
			propertyId,
			photoArr: list?.map((res) => {
				return res?.split( config?.country === "Saudi" ? "o/" : "net/")[1]
			})
		});


    if (response.success) {
			setIsShowModal(false)
      setReArrange(!reArrange)
			getPropertyById()
		}

    // const formData = new FormData()
    // formData.append('_id', propertyId)
    // for (let i = 0; i < list.length; i++) {
    //   formData.append('photos', list[i])
    // }
    // await apiPost(apiPath.uploadPhotos, formData)
  }
  return (
    <>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>
                  {t('Re-Arrange')}
                </h3>
                <button
                  className=' ml-auto  flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setIsShowModal(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl '>×</span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className='grid sm:grid-cols-3 max-h-[684px] overflow-y-scroll'>
                  {list.map((item, index) => (
                    <div
                      key={index}
                      className='w-[164px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden m-3'
                      onDragStart={e => dragStart(e, index)}
                      onDragEnter={e => dragEnter(e, index)}
                      onDragEnd={drop}
                      draggable
                    >
                      <figure className='w-full h-full'>
                        <OImage
                          src={
                            typeof item === 'object'
                              ? URL.createObjectURL(item)
                              : item
                          }
                          fallbackUrl='/images/user.png'
                          className='w-full h-full object-cover'
                          alt=''
                        />
                      </figure>
                    </div>
                  ))}
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                {/* <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setIsShowModal(false)}
                >
                  {t('O_CLOSE')}
                </button> */}
                <button
                  className='bg-[#8FC150] text-white active:bg-emerald-600 font-normal text-sm px-8 py-2.5 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150'
                  type='submit'
                  onClick={UploadPhotos}
                >
                  {t('O_SUBMIT')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </>
  )
}

export default ReArrangeModal
